module.exports = __webpack_public_path__ + "static/media/33.a36c72e8.jpg";